import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsCounterSource, PmsCounterSource } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsCounterSource>
    useData={usePmsCounterSource}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
